import { render, staticRenderFns } from "./peopleBox.vue?vue&type=template&id=4e9635ca&scoped=true"
import script from "./peopleBox.vue?vue&type=script&lang=js"
export * from "./peopleBox.vue?vue&type=script&lang=js"
import style0 from "./peopleBox.vue?vue&type=style&index=0&id=4e9635ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9635ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9635ca')) {
      api.createRecord('4e9635ca', component.options)
    } else {
      api.reload('4e9635ca', component.options)
    }
    module.hot.accept("./peopleBox.vue?vue&type=template&id=4e9635ca&scoped=true", function () {
      api.rerender('4e9635ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/peopleBox.vue"
export default component.exports